<template>
  <div>
    <button class="info-box" @click="expandInfo = !expandInfo">
      <div class="title">
        <div>
          <md-icon
            style="color: var(--pcolor) !important;"
            :aria-label="$t('info-box.title-link')"
            aria-hidden="true"
            role="presentation"
            >help_outline</md-icon
          ><span>{{ $t("info-box.title-link") }}</span>
        </div>
        <div>
          <md-icon
            style="color: var(--pcolor) !important;"
            :aria-label="$t('info-box.title-link')"
            aria-hidden="true"
            role="presentation"
            >{{ expandInfo ? "expand_less" : "expand_more" }}</md-icon
          >
        </div>
      </div>
      <div v-if="expandInfo">
        <div class="info-text">
          <div v-if="listOrCandidates == 'CANDIDATES'">
            <p class="info-vote">
              {{ $t("info-box.candidates.select-candidate.intro")
              }}<br v-if="this.$i18n.locale == 'en'" />
              {{ $t("info-box.candidates.select-candidate.info-vote") }}
              <span
                :aria-label="
                  $t(
                    'info-box.candidates.select-candidate.select-candidate-button'
                  )
                "
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t(
                      "info-box.candidates.select-candidate.select-candidate-button"
                    )
                  }}</md-tooltip
                >
                <md-icon
                  class="icon-align"
                  style="color: var(--pcolor) !important;"
                  :aria-label="
                    $t(
                      'info-box.candidates.select-candidate.select-candidate-button'
                    )
                  "
                  aria-hidden="true"
                  role="presentation"
                  >check_circle_outline</md-icon
                ></span
              >
              {{ $t("info-box.candidates.select-candidate.on-vote")
              }}<br /><span v-if="!showNullVote"
                >{{ $t("info-box.on-blank-vote") }} </span
              ><span v-if="showNullVote"
                >{{ $t("info-box.on-more-blank-vote") }}
              </span>
              <span v-if="showNullVote"
                >{{ $t("info-box.on-null-vote") }}
              </span>
              {{ $t("info-box.with") }}
              <span v-if="!showNullVote">{{ $t("info-box.the-button") }}</span
              ><span v-if="showNullVote">{{ $t("info-box.the-buttons") }}</span
              >.<br />
            </p>
            <p class="info-vote">
              {{ $t("info-box.icon") }}
              <span
                :aria-label="
                  $t(
                    'info-box.candidates.not-select-candidate.not-selectable-candidate-button'
                  )
                "
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t(
                      "info-box.candidates.not-select-candidate.not-selectable-candidate-button"
                    )
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  :aria-label="
                    $t(
                      'info-box.candidates.not-select-candidate.not-selectable-candidate-button'
                    )
                  "
                  aria-hidden="true"
                  role="presentation"
                  >block</md-icon
                ></span
              >
              {{
                $t("info-box.candidates.not-select-candidate.info-vote")
              }}.<br />
              {{ $t("info-box.icon") }}
              <span :aria-label="$t('info-box.candidates.info-candidate.info')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.candidates.info-candidate.info")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  style="color:rgba(0,0,0,0.8) !important"
                  :aria-label="$t('info-box.candidates.info-candidate.info')"
                  aria-hidden="true"
                  role="presentation"
                  >info_outline</md-icon
                ></span
              >
              {{ $t("info-box.candidates.info-candidate.more-info") }}. <br />
              <b>{{ $t("info-box.confirm-info") }}.</b>
            </p>
          </div>
          <div v-if="listOrCandidates == 'AFFILIATIONS' && hasPreferences">
            <p class="info-vote">
              {{ $t("info-box.affiliations.has-preferences.info-vote") }}
              <span
                :aria-label="
                  $t(
                    'info-box.affiliations.has-preferences.select-affiliation-button'
                  )
                "
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t(
                      "info-box.affiliations.has-preferences.select-affiliation-button"
                    )
                  }}</md-tooltip
                >
                <md-icon
                  class="icon-align"
                  style="color: var(--pcolor) !important;"
                  :aria-label="
                    $t(
                      'info-box.affiliations.has-preferences.select-affiliation-button'
                    )
                  "
                  aria-hidden="true"
                  role="presentation"
                  >check_circle_outline</md-icon
                ></span
              >. {{ $t("info-box.affiliations.has-preferences.next-step") }}
              <span
                :aria-label="
                  $t('info-box.affiliations.has-preferences.select-preferences')
                "
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t(
                      "info-box.affiliations.has-preferences.select-preferences"
                    )
                  }}</md-tooltip
                ><md-icon
                  class="md-size-1x pref icon-align"
                  style=" color: var(--pcolor)"
                  aria-hidden="true"
                  role="presentation"
                  >person</md-icon
                ></span
              >. {{ $t("info-box.affiliations.has-preferences.on-vote")
              }}<br />{{ $t("info-box.on-blank-vote") }}
              <span v-if="showNullVote"
                >{{ $t("info-box.on-null-vote") }}
              </span>
              {{ $t("info-box.with") }}
              <span v-if="!showNullVote">{{ $t("info-box.the-button") }}</span
              ><span v-if="showNullVote">{{ $t("info-box.the-buttons") }}</span
              >.
            </p>
            <p class="info-vote">
              {{ $t("info-box.icon") }}
              <span
                :aria-label="$t('info-box.affiliations.not-selectable.tooltip')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.affiliations.not-selectable.tooltip")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  :aria-label="
                    $t('info-box.affiliations.not-selectable.tooltip')
                  "
                  aria-hidden="true"
                  role="presentation"
                  >block</md-icon
                ></span
              >
              {{ $t("info-box.affiliations.not-selectable.info-vote") }}.<br />
              {{ $t("info-box.icon") }}
              <span
                :aria-label="$t('info-box.affiliations.info-affiliation.info')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.affiliations.info-affiliation.info")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  style="color:rgba(0,0,0,0.8) !important"
                  :aria-label="
                    $t('info-box.affiliations.info-affiliation.info')
                  "
                  aria-hidden="true"
                  role="presentation"
                  >info_outline</md-icon
                ></span
              >
              {{
                $t("info-box.affiliations.info-affiliation.more-info")
              }}.<br />
              <b>{{ $t("info-box.confirm-info") }}.</b>
            </p>
          </div>
          <div v-if="listOrCandidates == 'AFFILIATIONS' && !hasPreferences">
            <p class="info-vote">
              {{ $t("info-box.affiliations.no-preferences.info-vote") }}
              <span
                :aria-label="
                  $t(
                    'info-box.affiliations.no-preferences.select-affiliation-button'
                  )
                "
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t(
                      "info-box.affiliations.no-preferences.select-affiliation-button"
                    )
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  style="color: var(--pcolor) !important;"
                  :aria-label="
                    $t(
                      'info-box.affiliations.no-preferences.select-affiliation-button'
                    )
                  "
                  aria-hidden="true"
                  role="presentation"
                  >check_circle_outline</md-icon
                ></span
              >
              {{ $t("info-box.affiliations.no-preferences.on-vote") }}<br />{{
                $t("info-box.on-blank-vote")
              }}
              <span v-if="showNullVote"
                >{{ $t("info-box.on-null-vote") }}
              </span>
              {{ $t("info-box.with") }}
              <span v-if="!showNullVote">{{ $t("info-box.the-button") }}</span
              ><span v-if="showNullVote">{{ $t("info-box.the-buttons") }}</span
              >.
            </p>
            <p class="info-vote">
              {{ $t("info-box.icon") }}
              <span
                :aria-label="$t('info-box.affiliations.not-selectable.tooltip')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.affiliations.not-selectable.tooltip")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  :aria-label="
                    $t('info-box.affiliations.not-selectable.tooltip')
                  "
                  aria-hidden="true"
                  role="presentation"
                  >block</md-icon
                ></span
              >
              {{ $t("info-box.affiliations.not-selectable.info-vote") }}.<br />
              {{ $t("info-box.icon") }}
              <span
                :aria-label="$t('info-box.affiliations.info-affiliation.info')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.affiliations.info-affiliation.info")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  style="color:rgba(0,0,0,0.8) !important"
                  :aria-label="
                    $t('info-box.affiliations.info-affiliation.info')
                  "
                  aria-hidden="true"
                  role="presentation"
                  >info_outline</md-icon
                ></span
              >
              {{
                $t("info-box.affiliations.info-affiliation.more-info")
              }}.<br />
              <b>{{ $t("info-box.confirm-info") }}.</b>
            </p>
          </div>
          <div v-if="listOrCandidates == 'PREFERENCE'">
            <p class="info-vote">
              {{ $t("info-box.preferences.info-vote") }}
              <span
                :aria-label="$t('info-box.preferences.select-candidate-button')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.preferences.select-candidate-button")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  style="color: var(--pcolor) !important;"
                  :aria-label="
                    $t('info-box.preferences.select-candidate-button')
                  "
                  aria-hidden="true"
                  role="presentation"
                  >check_circle_outline</md-icon
                ></span
              >
              {{ $t("info-box.preferences.on-confirm-preference") }}.<br />{{
                $t("info-box.preferences.no-preference")
              }}.<br />
              <b>{{ $t("info-box.preferences.on-vote") }}</b>
            </p>
            <p class="info-vote">
              {{ $t("info-box.icon") }}
              <span
                :aria-label="
                  $t(
                    'info-box.candidates.not-select-candidate.not-selectable-candidate-button'
                  )
                "
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t(
                      "info-box.candidates.not-select-candidate.not-selectable-candidate-button"
                    )
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  :aria-label="
                    $t(
                      'info-box.candidates.not-select-candidate.not-selectable-candidate-button'
                    )
                  "
                  aria-hidden="true"
                  role="presentation"
                  >block</md-icon
                ></span
              >
              {{
                $t(
                  "info-box.candidates.not-select-candidate.not-selectable-candidate-button"
                )
              }}.<br />
              {{ $t("info-box.icon") }}
              <span
                :aria-label="$t('info-box.candidates.info-candidate.more-info')"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{
                    $t("info-box.candidates.info-candidate.info")
                  }}</md-tooltip
                ><md-icon
                  class="icon-align"
                  style="color:rgba(0,0,0,0.8) !important"
                  :aria-label="
                    $t('info-box.candidates.info-candidate.more-info')
                  "
                  aria-hidden="true"
                  role="presentation"
                  >info_outline</md-icon
                ></span
              >
              {{ $t("info-box.candidates.info-candidate.more-info") }}.
            </p>
          </div>
          <span class="screenreader">{{ $t("info-box.end-instruction") }}</span>
        </div>
      </div>
    </button>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
  },
  data: function() {
    return {
      isMobile: false,
      expandInfo: false,
      utils: null
    };
  },
  props: ["showNullVote", "listOrCandidates", "hasPreferences"],
  methods: {},
  computed: {},

  components: {}
};
</script>
<style scoped>
.istruzioni-text {
  padding-left: 40px;
}
.istruzioni-text:hover {
  text-decoration: none;
}
.title {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 5px;
}

.title span {
  padding-left: 30px;
  color: var(--pcolor) !important ;
  font-size: 16px;
}
.info-vote {
  margin-top: 0px;
  margin-bottom: 6px;
}
.icon-align {
  vertical-align: bottom;
}
.info-box {
  margin-bottom: 12px;
  border: 1px solid #ddd;
  padding: 15px 10px 10px 10px;
  width: 100%;
  text-align: left;
  background: #fff;
  border-radius: var(--br);
  cursor: pointer;
  margin-bottom: 15px;
  font-family: inherit;
}

.info-box:hover {
  background-color: #eee;
}

.info-box:focus-visible {
  border: 3px solid #000 !important;
  border-radius: var(--br);
}

.info-box .md-list-item {
  border: 1px solid #ccc;
  border-radius: var(--br);
}

.info-box .info-text {
  padding: 6px 20px 10px 20px;
  white-space: normal;
  line-height: 22px;
  font-size: 14px;
}

.info-box h4 {
  margin-bottom: 10px;
}

.info-box a {
  color: var(--pcolor) !important;
  cursor: pointer;
}

.text-list {
  list-style-type: disc;
  margin-left: 0;
  padding-left: 20px;
  margin-bottom: 5px;
}

.md-button {
  border-radius: var(--brb);
}

.md-list-item-expand {
  border: none;
}

.md-list-item-container.md-button-clean:hover {
  border-radius: var(--br);
}
</style>
